// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { languageMenuStyles } from "@stoneage/Overrides/Widgets/Common/LanguageMenu";
import { css } from "styled-components";
import { color } from "@stoneage/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { fontConfig } from "@stoneage/XDL/constants";

languageMenuStyles.languageSelect = {
    backgroundColor: "transparent",
    sizeVariant: "small",
    cssOverrides: {
        formField: css`
            padding: 8px 12px;
            & select:not(.react-datetime-picker__inputGroup__input):not(:disabled) {
                &,
                &:hover,
                &:focus,
                &:focus-within,
                &:not(:focus):hover {
                    height: initial;
                    padding-left: 0;
                    border: 0;
                    color: ${color("common.white")};
                    font-size: ${fontConfig.xSmallSingleLine.size}px;
                    line-height: ${fontConfig.xSmallSingleLine.lineHeight};
                    option {
                        color: ${color("text.main")};
                    }
                }
                & + ${IconWrapper} {
                    width: 13px;
                    height: 13px;
                    padding: 0;
                    color: ${color("common.ui6")};
                }
            }

            &&&& select {
                padding-right: 16px;
            }
        `,
    },
};
